import { render, staticRenderFns } from "./address_picker.vue?vue&type=template&id=62985db4&"
import script from "./address_picker.vue?vue&type=script&lang=coffee&"
export * from "./address_picker.vue?vue&type=script&lang=coffee&"
import style0 from "./address_picker.vue?vue&type=style&index=0&id=62985db4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports